import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import store from '../store';
import Inboxes from '../components/Inboxes';

function showInboxesDialog(props) {
  const $wrapper = document.createElement('div');
  $wrapper.classList.add('wrapperDialog');
  $wrapper.classList.add('wrapperMoveDialog');
  document.body.appendChild($wrapper);
  const root = createRoot($wrapper);

  function destroy() {
    root.unmount();
    document.body.removeChild($wrapper);
  }

  root.render(
    <Provider store={store}>
      <Inboxes destroy={destroy} {...props} />
    </Provider>,
  );
}

export default showInboxesDialog;
